import { getRangeValueAsPercentage } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
export const FormInputRange = ({ className, inputRef, max = '', min = '', onChange, progress, value, ...rest }) => {
    const [fill, setFill] = useState(getRangeValueAsPercentage({ max, min, value: `${value}` }));
    useEffect(() => {
        setFill(getRangeValueAsPercentage({ max, min, value: `${value}` }));
    }, [max, min, value]);
    // @ts-expect-error - React's event types are not self-compatible in this case
    const handleChange = (e) => {
        if (onChange)
            onChange(e);
        // Use state data if provided, or the element if not (vanilla can handle either)
        setFill(value
            ? getRangeValueAsPercentage({ max, min, value: `${value}` })
            : getRangeValueAsPercentage(e.target));
    };
    return (React.createElement("div", { className: "tds-form-input" },
        React.createElement("input", { className: cx('tds-form-input-range', {
                'tds-form-input-range--progress': progress,
            }, className), max: max, min: min, onChange: handleChange, ref: inputRef, 
            // @ts-expect-error - TS doesn't allow custom props to be set in style attribute
            style: { ['--tds-form-input-range--progress-width']: fill }, type: "range", value: value, ...rest })));
};
